import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { StaggerContainer, StaggerItem, MagneticButton } from '../../common/AnimationUtils';

import styles from '../styles/ExamplesSection.module.css';

const ExamplesSection = () => {
    return (
        <section className={styles.section}>
            <div className={styles.container}>
                <motion.div
                    className={styles.featureBlock}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <StaggerContainer className={styles.content} staggerChildren={0.15}>
                        <StaggerItem>
                            <span className={styles.label}>Built with JetChats</span>
                        </StaggerItem>
                        <StaggerItem>
                            <h2 className={styles.title}>
                                Your Personal<br />Flight Expert
                            </h2>
                        </StaggerItem>
                        <StaggerItem>
                            <p className={styles.description}>
                                Experience the power of autonomous agents. Our Flight Search Agent connects to APIs to find the best deals, track prices, and plan your perfect trip in seconds.
                            </p>
                        </StaggerItem>
                        <StaggerItem>
                            <MagneticButton>
                                <a href="https://jetchats.com/agent/flight_search_agent" target="_blank" rel="noopener noreferrer" className={styles.ctaButton}>
                                    Try Flight Agent
                                    <ArrowRight className={styles.arrowIcon} size={20} />
                                </a>
                            </MagneticButton>
                        </StaggerItem>
                    </StaggerContainer>

                    <motion.div
                        className={styles.visual}
                        initial={{ opacity: 0, x: 50, rotateY: -15 }}
                        whileInView={{ opacity: 1, x: 0, rotateY: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
                    >
                        <motion.div
                            className={styles.card}
                            whileHover={{ scale: 1.02, y: -5 }}
                            transition={{ duration: 0.3 }}
                        >
                            <div className={styles.cardHeader}>
                                <div className={styles.agentIcon}>F</div>
                                <div className={styles.agentInfo}>
                                    <h3>Flight Search Agent</h3>
                                </div>
                            </div>
                            <div className={styles.chatPreview}>
                                <div className={styles.message + ' ' + styles.userMessage}>
                                    Find me a flight to Tokyo next month, under $800.
                                </div>
                                <div className={styles.message + ' ' + styles.agentMessage}>
                                    I found 3 great options for you! The best deal is with ANA for $765, departing Oct 12th. Would you like to see the details?
                                </div>
                            </div>
                        </motion.div>
                    </motion.div>
                </motion.div>
            </div>
        </section>
    );
};

export default ExamplesSection;
